import { LocationDirection, Side, TranslateFunction } from "../../models/Common"
import { ISolution } from "../../models/Solution"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "../Base"
import { GlassOrder } from "../../models/Layers"
import { GlassOrderToColor } from "../Glass"
import { Surface, surfaceToStr } from "../../models/Customization"

export class GlassLayer extends BaseComponent {
  public constructor(
    thickness: number,
    order: GlassOrder,
    id: number,
    solution: ISolution,
    centralOffsetX: number,
    centralOffsetY: number,
    t: TranslateFunction,
    color?: string
  ) {
    let description =
      (order === 0
        ? t("glass_order_front")
        : order === 1
        ? t("glass_order_middle")
        : t("glass_order_rear")) + ` ${thickness} mm`
    description = description[0].toUpperCase() + description.substring(1)

    if (solution.glass.independentWH)
      description += `, ${t("width")}: ${solution.glass.width[order]} mm, ${t(
        "height"
      )}: ${solution.glass.height[order]} mm`
    if (order === GlassOrder.Front) {
      const customization = solution.customization
      if (customization)
        description += `, ${surfaceToStr(customization?.surface, t)}`
      if (customization?.surface === Surface.AntiGlare)
        description += ` (${customization.antiGlareType})`
    }
    const width = solution.glass.independentWH
      ? solution.glass.width[order]
      : solution.glass.width[0]
    super(
      {
        id,
        color: color || GlassOrderToColor(order),
        description: description,
      } as IComponentInfo,
      {
        width: width,
        height: thickness,
        centralOffsetX: centralOffsetX,
        centralOffsetY: centralOffsetY + thickness / 2,
      } as IComponentShape, // overall shape
      {
        dimensions: {
          sides: [Side.Right],
          diff: false,
        },
        id: {
          locationDirection: LocationDirection.Outward,
          fromSide: Side.Right,
          padding: 10 + (2 - order) * 20,
        },
        description: false,
      } as IComponentLabels
    )
  }
}
